export const COMMENTS_PAGE_SIZE = 100;
